import { Box, CardMedia, Icon, Typography } from '@mui/material'
import React from 'react'
import defaultImage from 'assets/images/default_avatar.png'
import PFeedbackModal from '../../performance-result/components/PFeedbackModal'

const TeamMemberCard = ({ isTeamMember, evaluationDetails, teamMemberDetails, reviewerLength }) => {
  return (
    <Box
      height="calc(100vh - 75px)"
      bgcolor="white.main"
      boxShadow="0px 0px 10px lightgray"
      position="sticky"
      top={75}
    >
      <Box
        width="100%"
        display="flex"
        alignItems="center"
        gap={2}
        borderBottom="solid 1px"
        borderBottomColor="gray-line.main"
        px={5}
        py={3}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          width={60}
          height={60}
          borderRadius="50%"
          backgroundColor={
            teamMemberDetails?.score || evaluationDetails?.evaluation_score
              ? 'light-yellow-01.main'
              : 'gray-background.main'
          }
        >
          <Icon
            sx={
              teamMemberDetails?.score || evaluationDetails?.evaluation_score
                ? {
                    color: 'yellow-01.main',
                    fontSize: '30px',
                  }
                : {
                    color: 'gray-inactive-button.main',
                    fontSize: '30px',
                  }
            }
          >
            workspace_premium
          </Icon>
        </Box>
        <Box>
          <Typography variant="h2" fontWeight="bold">
            {teamMemberDetails?.score
              ? Math.round(teamMemberDetails?.score * 50) / 10
              : evaluationDetails?.evaluation_score
              ? Math.round(evaluationDetails?.evaluation_score * 50) / 10
              : '--'}
          </Typography>
          <Typography color="light-gray-text.main">Score</Typography>
        </Box>
      </Box>
      <Box
        width="100%"
        display="flex"
        flexDirection="column"
        gap={2}
        borderBottom="solid 1px"
        borderBottomColor="gray-line.main"
        px={5}
        py={3}
      >
        <Typography color="light-gray-text.main">
          {!!isTeamMember ? 'Team member' : 'Employee'}
        </Typography>
        <Box display="flex" gap={2}>
          <CardMedia
            component="img"
            sx={{
              height: 60,
              width: 60,
              objectFit: 'cover',
              borderRadius: '50%',
            }}
            src={
              teamMemberDetails?.reviewee_image
                ? teamMemberDetails?.reviewee_image
                : teamMemberDetails?.profile_image
                ? teamMemberDetails?.profile_image
                : defaultImage
            }
          />
          <Box display="flex" flexDirection="column" justifyContent="center">
            <Typography noWrap>
              {teamMemberDetails?.reviewee_name ?? teamMemberDetails?.name}
            </Typography>
            <Typography color="light-gray-text.main" variant="body2">
              {teamMemberDetails?.reviewee_department_name ?? teamMemberDetails?.department_name}
            </Typography>
          </Box>
        </Box>
      </Box>

      {/* Feedback section */}
      {/* {teamMemberDetails?.reviewee_name !== teamMemberDetails?.reviewee_name && teamMemberDetails?.has_feedback === 1 && !teamMemberDetails?.feedback ? (
                <Box
                    width="100%"
                    display="flex"
                    justifyContent="center"
                    py={3}
                    sx={{
                        position: "absolute",
                        bottom: 0,
                    }}
                >
                    <PFeedbackModal submissionId={teamMemberDetails?.submission_id} />
                </Box>
                ) : teamMemberDetails?.reviewee_name !== teamMemberDetails?.reviewee_name && teamMemberDetails?.feedback ? (
                <Box px={5} py={3}>
                    <Typography variant="h4" color="light-gray-text.main" mb={2}>
                        My feedback
                    </Typography>
                    <Typography variant="h4">{teamMemberDetails?.feedback}</Typography>
                </Box>
                ) : null
            } */}
    </Box>
  )
}

export default TeamMemberCard
